<div class="progress-container">
    <div class="circle-con">
        <div class="txt-con" [class]="{'dis-none': page === 2 || page === 5}"><span>Schritt
                1</span><br><span>Registrieren</span></div>
        <div class="circle opacity-full icon-check-bg"></div>
    </div>
    <div class="line opacity-full"></div>
    <div class="circle-con">
        <div class="txt-con" [class]="{'dis-none': page === 2 || page === 5}"><span>Schritt 2</span><br><span
                [class]="{'ft-w-700': page === 1}">Organisation<br>erstellen</span></div>
        <div class="circle opacity-full" [class]="{'icon-check-bg': page === 3 || page === 4 || page === 5}"><span
                [class]="{'dis-inline': page === 2}">2</span></div>
    </div>
    <div class="line" [class]="{'opacity-full': page >= 3}"></div>
    <div class="circle-con">
        <div class="txt-con" [class]="{'dis-none': page === 2 || page === 5}"><span>Schritt 3</span><br><span
                [class]="{'ft-w-700': page === 3}">Zahlung</span></div>
        <div class="circle" [class]="{'opacity-full': page >= 3, 'icon-check-bg': page === 4 || page === 5}"><span
                [class]="{'dis-inline': page === 2}">3</span></div>
    </div>
    <div class="line" [class]="{'opacity-full': page >= 4}"></div>
    <div class="circle-con">
        <div class="txt-con" [class]="{'dis-none': page === 2 || page === 5}"><span>Schritt 4</span><br><span
                [class]="{'ft-w-700': page === 4}">Produkt<br>listen</span></div>
        <div class="circle" [class]="{'opacity-full': page >= 4}"><span
                [class]="{'dis-inline': page === 2 || page === 5}">4</span></div>
    </div>
</div>